import React from 'react';

import { Grid, Typography } from '@mui/material';

import { Job } from '@libs/graphql-types';
import { modelPath } from '@libs/helpers/form';
import ConnectedMultipleSelect from '@libs/ui/components/form/multiple-select/ConnectedMultipleSelect';

import { ApplicationFormState } from '../../types';

interface BayerLocationCodesProps {
  job: Job;
  showOnlyRequired?: boolean;
}

const BAYER_SITE_OPTIONS = `\
6
20
21
22
61
73
84
85
87
92
134
156
167
210
237
422
438
823
916
948
963
0A01
0A02
0A03
0A04
0A05
0A06
0A07
0A08
0A09
0A10
0A11
0A12
0A13
0A14
0A15
0A16
0A17
0A18
0A19
0A20
0A21
0A22
0A23
0A24
0A25
0A26
0A27
0A28
0A29
0A30
0A31
0A32
0A33
0A34
0A35
0A36
0A37
0A38
0A39
0A40
0A41
0A42
0A43
0A44
0A45
0A46
0A47
0A48
0A49
0A50
0A51
0A52
0A53
0A54
0A55
0A56
0A57
0A58
0A59
0A60
0A61
0A62
0A63
0A64
0A65
0A66
0A67
0A68
0A69
0A70
0A71
0A72
0A73
0A74
0A75
0A9B
0AD4
0AD5
0AJ1
0AJ2
0AJC
0AKC
0AL2
0AX2
1014
1122
1123
1125
1197
1229
1230
1233
1249
1254
1269
1287
1288
1291
1315
1318
1321
1330
1332
1334
1335
1345
1346
1353
1372
1384
1391
1477
1508
1546
1897
1C01
1C02
1CC1
1CC2
1CDS
1CH1
1CH2
1CH3
1CH4
1M02
1M04
1M12
1M14
1M15
1M1Z
1M49
1N01
1N02
2001
2074
2138
2174
2481
2D01
2DC1
2DC2
2DC3
2DC4
2DC5
2DH1
2DH2
2DH3
2DH4
2H01
2H77
2HJ1
2HRS
2HSS
2HTG
2L01
2L02
2L03
2L04
2N01
2N30
2N32
2N33
2N34
2N40
2N45
2N50
2O01
2O27
2O28
2O29
2O38
2O51
2P01
3077
3078
3256
3265
3266
3267
3268
3273
3352
3416
3429
3657
3663
3DIS
3L01
3L02
3L12
3L13
3L17
3L22
3L37
3L48
3L49
3LWF
3N01
3N04
3N11
3N20
3N25
3N42
3N43
3W1Z
3W2Z
3WA1
3WC1
3WC2
3WT1
4493
4586
4591
4592
4593
4595
4596
4847
4848
4849
4850
4851
4D01
4D02
4D03
4D04
4D05
4D06
4D07
4D08
4D09
4D10
4D11
4D12
4D13
4D14
4D15
4D16
4D17
4D18
4D19
4D20
4D21
4D22
4D23
4D24
4D25
4D26
4D27
4D28
4D29
4D30
4D31
4D32
4N01
4N18
4N35
4N41
4N47
4O01
4O02
4O03
4O04
4O05
4O06
4O07
4O08
4U01
4UDE
4UH1
4UH2
4UHN
5B55
5B56
5N01
5N14
5N16
5N21
5N26
5N31
5N36
5N39
5N44
5N46
5U01
5U02
6046
6229
6232
6233
6730
6R24
6R32
6R33
6R34
6R49
6R4Z
6RC3
6RTA
6RTB
6U01
6UDE
6UDF
6UH1
6UHN
6USR
6Z00
6Z9A
6ZC7
6ZIP
6ZJS
6ZL1
6ZM0
6ZMT
7060
7124
7K00
7N01
7O01
7O02
7O03
7O04
8H11
8H12
8H13
8H14
8H15
8H16
8H17
8H18
8H19
8H1A
8H1B
8H1C
8H1D
8H1E
8H1F
8H1G
8H1H
8H1J
8H1K
8H1L
8H1M
8H1N
8H1P
8H1Q
8H1R
8H1S
8H1T
8H1U
8H1V
8H1X
8H1Y
8H1Z
8H20
8H21
8H22
8H23
8H24
8H25
8H26
8H27
8H28
8H29
8H2A
8H2B
8H2C
8H2D
8H2E
8H2F
8H2G
8H2H
8H2J
8H2K
8H2L
8H2M
8H2N
8H2P
8H2Q
8H2R
8H2S
8H2T
8H2U
8H2V
8H2X
8H2Y
8H2Z
8H30
8H31
8H32
8H33
8H34
8H35
8H36
8H37
8H38
8H39
8H3A
8H3B
8H3C
8H3D
8H3E
8H3F
8H3G
8H3H
8H3J
8H3K
8H3L
8H3M
8H3N
8H3P
8H3Q
8H3R
8H3S
8H3T
8H3U
8H3V
8H3X
8H3Y
8H40
8H41
8H42
8H43
8H44
8H45
8H46
8H47
8H48
8H49
8H4A
8H4B
8H4C
8H4D
8H4E
8H4F
8H4G
8H4H
8H4J
8H4K
8H4L
8H4M
8H4N
8H4P
8H4Q
8H4R
8H4S
8H4T
8H4U
8H4V
8H4W
8H4X
8H4Y
8H50
8H51
8H52
8H53
8H54
8H55
8H56
8H57
8H58
8H59
8H5A
8H5B
8H5C
8H5D
8H5E
8H5F
8H5G
8H5H
8H5J
8H5K
8H5L
8H5M
8H5N
8H5P
8H5Q
8H5R
8H5S
8H5T
8H5U
8H5V
8H5W
8H5X
8H5Y
8H60
8H61
8H62
8H63
8H64
8H65
8H66
8H67
8H68
8H69
8H6A
8H6B
8H6C
8H6D
8H6E
8H6F
8H6G
8H6H
8H6J
8H6K
8H6L
8H6M
8H6N
8H6P
8H6Q
8H6R
8H6S
8H6T
8H6U
8H6V
8H6W
8H70
8H71
8H72
8H73
8H74
8H75
8H76
8H77
8H78
8H79
8H7N
8H80
8H81
8H82
8H83
8H84
8H85
8H86
8H87
8H88
8H89
8H8N
8H90
8H91
8H92
8H93
8H94
8H95
8H96
8H97
8H98
8H99
8HA1
8HA2
8HA3
8HA4
8HA5
8HA6
8HA7
8HA8
8HA9
8HAA
8HAB
8HAC
8HAD
8HAE
8HAF
8HB1
8HB2
8HB3
8HB4
8HB5
8HB6
8HB7
8HB8
8HB9
8HC1
8HC2
8HC3
8HC4
8HC5
8HC6
8HC7
8HC8
8HC9
8HCN
8HCR
8HCS
8HCT
8HD1
8HD2
8HD3
8HD4
8HD5
8HD6
8HD7
8HD8
8HD9
8HDA
8HDB
8HDC
8HDD
8HDE
8HDF
8HE1
8HE2
8HE3
8HE4
8HE5
8HE6
8HE7
8HE8
8HE9
8HF1
8HF2
8HF3
8HF4
8HF5
8HF6
8HF7
8HF8
8HF9
8HFH
8HG1
8HG2
8HG3
8HG4
8HG5
8HG6
8HG7
8HG8
8HG9
8HGA
8HH1
8HH2
8HH3
8HH4
8HH5
8HH6
8HH7
8HH8
8HH9
8HJD
8HJN
8HJZ
8HK1
8HK2
8HK3
8HK4
8HK5
8HK6
8HK7
8HK8
8HK9
8HL1
8HL2
8HL3
8HL4
8HL5
8HL6
8HL7
8HL8
8HL9
8HM1
8HM2
8HM3
8HM4
8HM5
8HM7
8HM8
8HN1
8HN2
8HN3
8HN4
8HN5
8HN6
8HN7
8HN8
8HN9
8HP1
8HP2
8HP3
8HP4
8HP5
8HP6
8HP7
8HP8
8HP9
8HQM
8HS7
8HSY
8HWF
8HWL
8HWS
8J01
8J32
8J33
8J34
8J49
8J52
8JC1
8NA0
8NA1
8NA2
8NA3
8NA4
8NA5
8NA6
8NA7
8NA8
8NA9
8NAA
8NAB
8NAC
8NAD
8NAE
8NAF
8NAG
8NAH
8NAI
8NAJ
8NAK
8NAL
8NAM
8NAN
8NAO
8NAP
8NAQ
8NAR
8NAS
8NAT
8NAU
8NAV
8NAW
8NAX
8NAY
8NAZ
8NB0
8NB1
8NB2
8NB3
8NB4
8NB5
8NB6
8NB7
8NB8
8NB9
8NBA
8NBB
8NBC
8NBD
8NBE
8NBF
8NBG
8NBH
8NBI
8NBJ
8NBK
8NBL
8NBM
8NBN
8NBO
8NBP
8NBQ
8NBR
8NBS
8NBT
8NBU
8NBV
8NBW
8NBX
8NBY
8NBZ
8S00
8S01
8T1Z
8T21
8T2Z
8T31
8T41
8T51
8TSC
8TT2
8V1A
8V1B
8V1C
8V1D
8V1E
8V1F
8V1G
8V1H
8V1I
8V1J
8V1K
8V1L
8V1M
8V1N
8V1O
8V1P
8V1Q
8V1R
8V1S
8V1T
8V1U
8V1V
8V1W
8V1X
8V1Y
8V1Z
8V2A
8V2B
8V2C
8V2D
8V2E
8V2F
8V2G
8V2H
8V2I
8V2J
8V2K
8V2L
8V2M
8V2N
8V2O
8V2P
8V2Q
8V2R
8V2S
8V2T
8V2U
8V2V
8V2W
8V2X
8V2Y
8V2Z
8V3A
8V3B
8V3C
8V3D
8V3E
8V3F
8V3G
8V3H
8V3I
8V3J
8V3K
8V3L
8V3M
8V3N
8V3O
8V3P
8V3Q
8V3R
8V3S
8V3T
8V3U
8V3V
8V3W
8V3X
8V3Y
8V3Z
8V4A
8V4B
8V4C
8V4D
8V4E
8V4F
8V4G
8V4H
8V4I
8V4J
8V4K
8V4L
8V4M
8V4N
8V4O
8V4P
8V4Q
8V4R
8V4S
8V4T
8V4U
8V4V
8V4W
8V4X
8V4Y
8V4Z
8V5A
8V5B
8V5C
8V5D
8V5E
8V5F
8V5G
8V5H
8V5I
8V5J
8V5K
8V5L
8V5M
8V5N
8V5O
8V5P
8V5Q
8V5R
8V5S
8V5T
8V5U
8V5V
8V5W
8V5X
8V5Y
8V5Z
8V6A
8V6B
8V6C
8V6D
8V6E
8V6F
8V6G
8V6H
8V6I
8V6J
8V6K
8V6L
8V6M
8V6N
8V6O
8V6P
8V6Q
8V6R
8V6S
8V6T
8V6U
8V6V
8V6W
8V6X
8V6Y
8V6Z
8V7A
8V7B
8V7C
8V7D
8V7E
8V7F
8V7G
8V7H
8V7I
8V7J
8V7K
8V7L
8V7M
8V7N
8V7O
8V7P
8V7Q
8V7R
8V7S
8V7T
8V7U
8V7V
8V7W
8V7X
8V7Y
8V7Z
8V8A
8V8B
8V8C
8V8D
8V8E
8V8F
8V8G
8V8H
8V8I
8V8J
8V8K
8V8L
8V8M
8V8N
8V8O
8V8P
8V8Q
8V8R
`
  .trim()
  .split(/\s+/)
  .map((code) => ({ text: code, value: code }));

/**
 * Bayer-specific Location Codes form component
 * This component renders a custom location code form for Bayer job applications
 * with Bayer-specific location options and labeling
 */
export const BayerLocationCodes: React.FC<BayerLocationCodesProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  return (
    <>
      <Grid item>
        <ConnectedMultipleSelect
          name={modelPath<ApplicationFormState>((i) => i.details.siteCode)}
          options={BAYER_SITE_OPTIONS}
          autoCompleteProps={{
            multiple: false,
            freeSolo: true,
          }}
          inputProps={{
            fullWidth: true,
            variant: 'filled',
            label: (
              <Typography>
                Bayer Site/Plant{' '}
                <Typography component="span" color="error">
                  *
                </Typography>
              </Typography>
            ),
          }}
        />
      </Grid>

      <Grid item>
        <ConnectedMultipleSelect
          name={modelPath<ApplicationFormState>((i) => i.details.siteCode)}
          options={BAYER_SITE_OPTIONS}
          autoCompleteProps={{
            multiple: false,
            freeSolo: true,
            disabled: true,
          }}
          inputProps={{
            fullWidth: true,
            variant: 'filled',
            label: (
              <Typography>
                Bayer Location Code{' '}
                <Typography component="span" color="error">
                  *
                </Typography>
              </Typography>
            ),
          }}
        />
      </Grid>
    </>
  );
};
